import {format, formatRelative} from 'date-fns'
import {ru} from 'date-fns/locale'

class DateService {

    format(date, time = false, formatStr = 'dd.MM.yyyy',) {
        if (!date) return ''
        date = new Date(date)
        if (time) formatStr += ' H:mm';
        return format(date, formatStr, {
            locale: ru
        })
    }

    formatDate(date) {
        return this.format(date)
    }
    formatDateLong(date) {
        return this.format(date, false, 'PPP')
    }

    formatRelative(date) {
        date = new Date(date)
        return formatRelative(date, new Date(), {locale: ru})
    }

    formatDateWithTime(date) {
        return this.format(date, true)
    }

    formatDateEn(date) {
        if (!date)
            return ''
        return format(date, 'yyyy-MM-dd')
    }

}

export default new DateService();


